// extracted by mini-css-extract-plugin
export var bodySections = "_d4-8";
export var gray = "_d4-7";
export var green = "_d4-4";
export var iconContainer = "_d4-9";
export var iconWidgetContainer = "_d4-1";
export var phoneIcon = "_d4-2";
export var red = "_d4-5";
export var statusDot = "_d4-3";
export var widgetContainer = "_d4-0";
export var yellow = "_d4-6";